module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/2010aac719d9d7c4b3edb40f3097c2f5.svg";